import { isUndef } from "@/lib/utils";
import { ShopV2 } from "@/store/shopV2";

export default class OrderDetailData {
    public id: number
    public activity_id: number
    public name: string
    public gender: string
    public mobile: string
    public district_1: string
    public district_2: string
    public district_3: string
    public district: Array<string>
    public address: string
    public status: string
    public type: string
    public express_company: string
    public express_number: string
    public express_detail: string
    public can_change_before: string
    public choices: Equipment.ChoiceItem[];
    public choices_o: Equipment.ChoiceItem[];
    public gift: ShopV2.OrderGift
    public specification: number
    public can_change: boolean
    public is_after_sale = false

    public constructor(detail: ShopV2.OrderDetail) {
        this.choices_o = detail.choices;
        this.choices = detail.choices.filter(ele => ((ele.left_count ?? 999) || (ele.left_count === 0 && ele.id === +detail.specification ? 1 : 0)) > 0)
        this.id = detail.id
        this.activity_id = detail.activity_id
        this.name = detail.name
        this.gender = detail.gender
        this.mobile = detail.mobile
        this.district_1 = detail.district_1
        this.district_2 = detail.district_2
        this.district_3 = detail.district_3
        this.district = [ detail.district_1, detail.district_2, detail.district_3 ].filter((_) => _);
        this.address = detail.address
        this.status = detail.status
        this.type = detail.type
        this.express_company = detail.express_company
        this.express_number = detail.express_number
        this.express_detail = detail.express_detail
        this.can_change_before = detail.can_change_before
        this.can_change = detail.can_change
        this.gift = detail.gift
        this.specification = +detail.specification!
    }

    public get giftInfo() {
        return {
            ...this.gift,
            choices: this.choices,
            specification: this.specification,
        }
      }

    public getSpec() {
        if (!this.specification) {
            return '';
        }
        for (const choice of this.choices) {
            if (choice.id === this.specification) {
                return [
                    this.gift.spec_1 ? this.gift.spec_1 + ':' : null,
                    choice.spec_1,
                    this.gift.spec_2 ? this.gift.spec_2 + ':' : null,
                    choice.spec_2,
                    this.gift.spec_3 ? this.gift.spec_3 + ':' : null,
                    choice.spec_3,
                ].filter((_) => _).join(' ');
            }
        }
        for (const choice of this.choices_o) {
            if (choice.id === this.specification) {
                return [
                    this.gift.spec_1 ? this.gift.spec_1 + ':' : null,
                    choice.spec_1,
                    this.gift.spec_2 ? this.gift.spec_2 + ':' : null,
                    choice.spec_2,
                    this.gift.spec_3 ? this.gift.spec_3 + ':' : null,
                    choice.spec_3,
                ].filter((_) => _).join(' ');
            }
        }
        return '';
    }
    public canModify() {
        // let canModify = isUndef(this.can_change_address) ? false : this.can_change_address;
        // if (this && this.gifts) {
        //     this.gifts.forEach((gift: EquipmentGift) => {
        //         if (gift.can_change === true) {
        //             canModify = true;
        //         }
        //     });
        // }
        // return canModify;
    }
}
